




































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { merge } from 'lodash-es'
import A from '@/utilities/alpha'
import InsightViewer from './InsightViewer.vue'
import InsightList from './InsightList.vue'
import * as db from '@shared/types/database'
import * as ui from '@/types/frontend'
import api from '@/api'
import store from '@/store'
import { PresetTestMessages } from '../../store/modules/notification-store-module'
import { Button, Card } from '@alpha/ink'
import { VUE_APP_LEGACY_API } from '@/config'

@Component({
  components: {
    InsightViewer,
    InsightList,
    Card,
    Button
  }
})
export default class ResultsSection extends Vue {
  @Prop({ required: true }) test!: db.Test
  @Prop({ required: true }) workspaceId!: string
  @Prop({ required: true }) testId!: string

  qualInsightCount: number = 0
  qualNotable = this.test.payload.qualNotable || []
  activeInsightIndex: number | false = false
  prevInsight: number = 0

  set toast (value: string | false) {
    store.dispatch.notification.setMessage(value)
  }

  get toast () {
    return store.state.notification.message
  }

  get title () {
    return this.test.payload.title
  }

  get status () {
    return this.test.payload.status
  }

  get assets (): ui.DynamicAsset[] {
    const { assets } = this.test.payload
    if (assets) {
      const assetIds = Object.keys(assets)
      const processedAssets: ui.DynamicAsset[] = []
      assetIds.forEach(key => {
        // add asset id as a property of the object
        const asset = A.clone(assets[key]) as ui.DynamicAsset
        asset.id = key
        processedAssets.push(asset)
      })
      return processedAssets
    } else {
      return []
    }
  }

  get activeInsight () {
    if (typeof this.activeInsightIndex === 'number') {
      return this.insights[this.activeInsightIndex]
    }
  }

  get insights (): ui.DynamicAsset[] {
    if (!this.assets) return []
    const dynamicQualAssets: ui.DynamicQualAsset[] = []
    const dynamicAssetKey = '123456789' // not needed?
    const finalAssets: ui.DynamicAsset[] = this.assets.map((asset, idx) => {
      const newAsset = Object.assign({}, asset)
      newAsset.idx = idx
      newAsset.alphaAnalysis = (asset.alphaAnalysis && asset.alphaAnalysis.trim()) || ''
      newAsset.hasInsights = this.hasInsights(newAsset)
      if ((newAsset.asset_type === 'textResponses' || newAsset.type === 'textFrequency') && newAsset.url.indexOf('staticassets') === -1) {
        const reformatUrl = (url: string): string => {
          const endOfUrl = url.split('/').pop()
          return endOfUrl ? '/staticassets/text/' + endOfUrl.split('_')[0] : url
        }
        newAsset.url = reformatUrl(newAsset.url)
      } else if (newAsset.asset_type === 'viz-slice' && newAsset.charts) {
        const firstChart = Object.keys(newAsset.charts)[0]
        newAsset.url = newAsset.charts[firstChart].url
      } else if (newAsset.asset_type === 'aud-slice' && newAsset.charts) {
        const keys = Object.keys(newAsset.charts)
        newAsset.url = newAsset.charts[keys[0]].url
      }
      // qual video analysis is a JSON object of ques/answers
      if (newAsset.logger_notes || newAsset.loggerNotes) {
        const logs = newAsset.logger_notes || newAsset.loggerNotes
        let analysisObj: db.LoggerNote[] = []
        if (typeof logs === 'string' && A.isJsonString(logs)) {
          analysisObj = JSON.parse(logs)
        }
        if (Array.isArray(analysisObj)) {
          for (let k = 0; k < analysisObj.length; k++) {
            analysisObj[k].number_of_actual_insights = this.assets.length
          }
        }
        newAsset.logger_notes = analysisObj
        if (!analysisObj) {
          console.error('Failed to find analysis for asset: ', newAsset)
          return newAsset
        }
        // build matrix view of each ques with all responses from every user
        for (let i = 0; i < analysisObj.length; i++) {
          if (dynamicQualAssets[i]) {
            dynamicQualAssets[i].answers.push({
              content: 'Session ' + (newAsset.session_id || '????') + ' ' + analysisObj[i].answer,
              show: true,
              id: i,
              type: 'answer'
            })
            continue
          }
          dynamicQualAssets.push({
            id: dynamicAssetKey + i,
            questionNumber: i,
            idx: this.assets.length + dynamicQualAssets.length,
            dynamicQual: true,
            title: analysisObj[i].question,
            type: 'textResponses',
            asset_type: 'textResponses',
            filename: (i + 1) + '. ' + analysisObj[i].question,
            subtitle: 'Representative Responses',
            alphaAnalysis: '',
            url: '',
            answers: [{
              content: 'Session ' + (newAsset.session_id || '????') + ' ' + analysisObj[i].answer,
              show: true,
              id: i,
              type: 'answer'
            }]
          })
        }
      }
      return newAsset
    })
    if (dynamicQualAssets.length > 0 && dynamicQualAssets[0].answers.length > 1) {
      for (let i = 0; i < dynamicQualAssets.length; i++) {
        dynamicQualAssets[i].subtitle = 'Sample size: ' + dynamicQualAssets[i].answers.length + ' users'
        finalAssets.push(dynamicQualAssets[i])
      }
      this.qualInsightCount = dynamicQualAssets.length
    }
    return finalAssets
  }

  mounted () {
    this.updateActiveInsightByHash()
    this.insightAnchorClickHandlers()
  }

  insightAnchorClickHandlers () {
    const linksToInsights = document.querySelectorAll('.key-insights .insight-card .redactor-box a')
    linksToInsights.forEach(linkHL => {
      linkHL.addEventListener('click', (e: Event) => {
        e.preventDefault()
        // @ts-ignore
        this.updateActiveInsightByHash(e!.target!.hash!)
      })
    })
  }

  updateActiveInsightByHash (hash?: string) {
    let assetId = hash || window.location.hash
    if (assetId[0] === '#') {
      assetId = assetId.slice(1)
    }
    if (assetId) {
      const assetIndex = this.insights.findIndex(function (insight) {
        return insight.id === assetId
      })
      if (assetIndex > -1) {
        this.activeInsightIndex = assetIndex
      }
    }
  }

  @Watch('activeInsightIndex')
  updateHashAndScrollIntoView () {
    if (this.activeInsightIndex !== false) {
      const insightId = this.insights[this.activeInsightIndex].id
      history.replaceState(null, document.title, `#${insightId}`)
      this.scrollInsightIntoView()
    } else {
      history.replaceState(null, document.title, '#')
    }
  }

  scrollInsightIntoView () {
    (this.$refs.insightViewerAnchor as Element).scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    })
  }

  showCSVLink () {
    return this.test.payload.status === 'Complete' && this.hasAssetsWithRawData
  }

  hasAssetsWithRawData () {
    if (!this.test.payload.assets) return false
    return Object.keys(this.test.payload.assets)
      .some(assetId => {
        return this.test.payload.assets[assetId].rawData
      })
  }

  downloadCSVDataURL () {
    const exportDemos = ['Age', 'Gender', 'Employment', 'HHI']
    const mgtLink = VUE_APP_LEGACY_API

    window.open(`${mgtLink}/${this.workspaceId}/${this.testId}/download-csv-data?demos=${exportDemos.join(',')}`, '_blank')
  }

  selectInsight (newInsightIndex: number) {
    if (this.activeInsightIndex) this.prevInsight = this.activeInsightIndex
    this.activeInsightIndex = newInsightIndex
  }

  // Just goes back to the previous, used for dynamic insights
  backInsight () {
    this.activeInsightIndex = this.prevInsight
    this.prevInsight = 0
  }

  selectPrev () {
    const prev = (this.activeInsightIndex === 0) ? (this.insights.length - this.qualInsightCount) - 1 : (this.activeInsightIndex as number) - 1
    this.activeInsightIndex = prev
  }

  selectNext () {
    const next = this.activeInsightIndex === (this.insights.length - this.qualInsightCount) - 1 ? 0 : (this.activeInsightIndex as number) + 1
    this.activeInsightIndex = next
  }

  shrink () {
    this.activeInsightIndex = false
  }

  expand () {
    this.activeInsightIndex = 0
  }

  updateInsight (mutations: ui.Mutations) {
    // fetch the right asset first + remove idx if it was present
    if (typeof mutations.assetIdx !== 'number' && typeof this.activeInsightIndex !== 'number') {
      console.error('No selected asset available to update')
      return
    }
    const assetIdx: number = mutations.assetIdx ? mutations.assetIdx : this.activeInsightIndex as number
    delete mutations.assetIdx

    // Set current asset's properties in insights array
    const assetId = this.assets[assetIdx].id
    // Set original assets object data to reflect updates
    const originalAsset = this.test.payload.assets[assetId]
    const newAsset = Object.assign({}, merge(originalAsset, mutations))
    const assets = Object.assign({}, this.test.payload.assets, { [assetId]: newAsset })
    // Prepare data for upload
    const data: Partial<db.TestPayload> = { assets }
    const { workspaceId, testId } = this.$route.params
    store.dispatch.workspace.updateTest({ test: data, workspaceId, testId })
      .then(() => {
        this.toast = PresetTestMessages.updateSuccess
      }).catch((error: any) => {
        console.error(error)
        this.toast = PresetTestMessages.updateFail
      }).finally(() => {
        setTimeout(() => {
          this.toast = false
        }, 3000)
      })
  }

  hasInsights (asset: ui.DynamicAsset) {
    const { charts, textResponses } = asset
    const slices = charts || textResponses
    if (!slices) {
      if (asset.type !== 'wordcloud') console.warn('No chart views available for asset:', asset)
      return false
    }
    const keys = Object.keys(slices)
    const availableInsights = keys.filter(key => {
      const value = slices[key]
      return value.alphaAnalysis
    })
    return availableInsights.length > 0
  }

  updateQualNotable (dynamicInsight: ui.DynamicQualAsset) {
    let added: boolean
    const inNotables = this.qualNotable.findIndex((notable) => {
      return notable.questionNumber === dynamicInsight.questionNumber && notable.questionText === dynamicInsight.title
    })
    if (inNotables !== -1) {
      this.qualNotable.splice(inNotables, 1)
      added = false
    } else {
      this.qualNotable.push({
        questionNumber: dynamicInsight.questionNumber,
        questionText: dynamicInsight.title
      })
      added = true
    }
    const { workspaceId, testId } = this.$route.params
    const payload = JSON.stringify(this.qualNotable)
    api.updateQualNotable(payload, { workspaceId, testId })
      .then((res) => {
        // Only give a success message for adding
        if (added) {
          this.toast = 'This can be found on your Shareable Report!'
          setTimeout(() => {
            this.toast = false
          }, 2000)
        }
      })
  }
}
